import store from 'store';
import { ACT_CMS } from 'store/actions/act';

// ----------  Routes ----------
import CheckinoutRoutes from './checkinout-routes';
import CampsRoutes from './camps-routes';
import TransportationRoutes from './transportation-routes';
// ----------  Routes ----------

const Layout = () => import(/* webpackChunkName: "pages/main" */ 'layout');
const Error = () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error');
const Legal = () => import(/* webpackChunkName: "pages/views/legal" */ 'views/Legal');
const PageAccessDenied = () =>
  import(
    /* webpackChunkName: "pages/views/error/access-denied" */
    'views/Error/AccessDenied'
  );
const SelectionFlow = () =>
  import(/* webpackChunkName: "pages/views/selection-flow" */ 'views/SelectionFlow');

/** ******************** LOGIN *********************** */
/** ************************************************** */
const OidcLoginEmployees = () =>
  import(/* webpackChunkName: "pages/oidc/loginEmployee" */ '@/pages/main/Oidc/OidcLoginEmployees');
const OidcLoginPartners = () =>
  import(/* webpackChunkName: "pages/oidc/loginPartners" */ '@/pages/main/Oidc/OidcLoginPartners');
const OidcCallback = () =>
  import(
    /* webpackChunkName: "pages/oidc/callback" */
    '@/pages/main/Oidc/OidcCallback'
  );

/** ******************** LOGIN *********************** */
/** ************************************************** */

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

// Redirect to the 404 page
// eslint-disable-next-line no-unused-vars
const redirectTo404Page = (next, path) => next({ name: '404', params: { 0: path } });

export default [
  {
    path: '/oidc-callback',
    name: 'oidc-callback',
    component: OidcCallback,
    meta: { titleKey: 'oidcCallback', withoutFlowTabs: true }
  },
  {
    path: '/',
    component: Layout,
    name: 'home',
    meta: { withoutFlowTabs: true },
    children: [
      // Identity --------------------------------------------------------------
      {
        path: '/login/employees',
        component: OidcLoginEmployees,
        meta: { titleKey: 'loginEmployees', withoutFlowTabs: true },
        name: 'loginEmployees',
        beforeEnter(to, from, next) {
          Promise.all([
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'login-employees-titular'
            })
          ])
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: '/login/partners',
        component: OidcLoginPartners,
        meta: { titleKey: 'loginPartners', withoutFlowTabs: true },
        name: 'loginPartners',
        beforeEnter(to, from, next) {
          Promise.all([
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'login-partners-titular'
            })
          ])
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },

      // Flows ------------------------------------------------------------------
      {
        path: '/selection-flow',
        name: 'selectionFlow',
        component: SelectionFlow,
        meta: { titleKey: 'selectionFlow', withoutFlowTabs: true }
      },
      ...CheckinoutRoutes,
      ...CampsRoutes,
      ...TransportationRoutes,
      // Errors ----------------------------------------------------------------
      {
        path: '/access-denied',
        name: 'access-denied',
        component: PageAccessDenied,
        meta: { titleKey: 'accessDenied', withoutFlowTabs: true }
      },
      {
        path: '/legal/:type',
        component: Legal,
        name: 'legal',
        // props: { whithoutLinksFooter: true },
        meta: { titleKey: 'legal', withoutFlowTabs: true }
      },
      {
        path: '/error',
        name: 'error',
        component: Error,
        props: { type: '500_es-ES' },
        meta: { titleKey: 'error', withoutFlowTabs: true }
      }
    ]
  },
  {
    path: '*',
    component: Layout,
    children: [
      {
        path: '/',
        name: '404',
        component: Error,
        props: { type: '404_es-ES' },
        meta: { titleKey: 'notFound', withoutFlowTabs: true }
      }
    ]
  }
];
